angular.module('b2bLoginApp.services').factory('CompanySites', ['$resource',
    function ($resource) {
        return $resource('sites.json');
    }
]);
